<template>
  <div>
    <!--顶部标题菜单-->
    <div class = "header">
      <p class = "h_title">请求获取联赛名</p>
      <a @click = "back" href = "javascript:void(0)" class = "h_btn" ></a>
    </div>

    <div class = "match">
      <div class = "m_box">
        <div class = "mb_time">10/05 02:45</div>
        <ul class = "mb_info">
          <li class = "mb_sider">
            <div class = "mb_img"><img src = "../../static/image/teamlogo3.png" /></div>
            <div class = "mb_name">Paris Saint-Germain</div>
          </li>
          <li class = "mb_center">VS</li>
          <li class = "mb_sider">
            <div class = "mb_img"><img src = "../../static/image/teamlogo3.png" /></div>
            <div class = "mb_name">Bayern Munich</div>
          </li>
        </ul>
      </div>
    </div>

    <div class = "nav">
      <ul class = "flex">
        <li @click = "tab(0)" :class = "tabIndex == 0 ? 'on' : ''" class = "noBorder flex-1 flex flex-align-center flex-pack-center">
          <div>Guess</div>
        </li>
        <li @click = "tab(1)" :class = "tabIndex == 1 ? 'on' : ''" class = "flex-1 flex flex-align-center flex-pack-center">
          <div>Stat.</div>
        </li>
        <li @click = "tab(2)" :class = "tabIndex == 2 ? 'on' : ''" class = "flex-1 flex flex-align-center flex-pack-center">
          <div>Key Guess Point</div>
        </li>
        <li @click = "tab(3)" :class = "tabIndex == 3 ? 'on' : ''" class = "flex-1 flex flex-align-center flex-pack-center">
          <div>查看记录</div>
        </li>
      </ul>
    </div>

    <div class = "main">
      <div class = "m_guess" v-if = "tabIndex == 0">
        <ul>
          <li>
            <div class = "mg_title"><span>1x2</span><span class = "mg_odds"></span></div>
            <ul class = "mg_option flex">
              <li class = "selected flex-1 noBorder flex flex-align-center flex-pack-center">
                <div>
                  <p>Home Win</p>
                  <p><span class = "odds_up">1.15</span></p>
                </div>
                <div class = "on"></div>
                <div class = "on2">Placed</div>
              </li>
              <li class = "flex-1 flex flex-align-center flex-pack-center">
                <div>
                  <p>Draw</p>
                  <p><span class = "odds_down">1.15</span></p>
                </div>
                <div class = "on"></div>
                <div class = "on2">Placed</div>
              </li>
              <li class = "flex-1 flex flex-align-center flex-pack-center"> 
                <div>
                  <p>Away Win</p>
                  <p><span>1.15</span></p>
                </div>
                <div class = "on"></div>
                <div class = "on2">Placed</div>
              </li>
            </ul>
          </li>

          <li>
            <div class = "mg_title"><span>AH</span><span class = "mg_odds">(0.5/1)</span></div>
            <ul class = "mg_option flex">
              <li class = "betOn flex-1 noBorder flex flex-align-center flex-pack-center">
                <div>
                  <p>Home Win</p>
                  <p><span>1.15</span></p>
                </div>
                <div class = "on"></div>
                <div class = "on2">Placed</div>
              </li>
              <li class = "flex-1 flex flex-align-center flex-pack-center">
                <div>
                  <p>Draw</p>
                  <p><span>1.15</span></p>
                </div>
                <div class = "on"></div>
                <div class = "on2">Placed</div>
              </li>
            </ul>
          </li>

          <li>
            <div class = "mg_title"><span>Over/Under</span><span class = "mg_odds">(3)</span></div>
            <ul class = "mg_option flex locked">
              <li class = "flex-1 noBorder flex flex-align-center flex-pack-center">
                <div>
                  <p>Home Win</p>
                  <p><span>1.15</span>(Closed)</p>
                </div>
                <div class = "on"></div>
                <div class = "on2">Placed</div>
              </li>
              <li class = "flex-1 flex flex-align-center flex-pack-center">
                <div>
                  <p>Draw</p>
                  <p><span>1.15</span>(Closed)</p>
                </div>
                <div class = "on"></div>
                <div class = "on2">Placed</div>
              </li>
            </ul>
          </li>
        </ul>

        <div class = "mg_point">
          <div class = "mgp_btn">
            <a href = "javascript:void(0)">设为重点</a>
          </div>
          <p class = "mgp_tip">其他用户可以查看你的重点投注</p>
          <p class = "mgp_tip">每一位用户查看，你将会得到1-10M券奖励</p>
        </div>
        <div class = "mg_point">
          <div class = "mgp_copy">
            <span class = "mgp_l">Key Guess Point</span>
            <span class = "mgp_r"><a href = "javascript:void(0);">复制链接分享比赛</a></span>
          </div>
          <p class = "mgp_tip">让更多用户看到你的投注，同时你将得到更多的奖励</p>
        </div>
        <div  v-show = "false">
          <a>查看更多竞猜 >></a>
        </div>
      </div>

      <div class = "m_guess" v-if = "tabIndex == 1">
        <ul>
          <li>
            <div class = "mg_title"><span>1x2</span><span class = "mg_odds"></span></div>
            <ul class = "mg_total">
              <li class = "mgt_c1">
                <p class = "mgt_title">Win</p>
                <div class = "mgt_l">
                  <div style = "width:50%"></div>
                </div>
                <div class = "mgt_r">
                  <span>57.8% (833)</span>
                </div>
              </li>
              <li class = "mgt_c2">
                <p class = "mgt_title">Draw</p>
                <div class = "mgt_l">
                  <div style = "width:50%"></div>
                </div>
                <div class = "mgt_r">
                  <span>57.8% (8)</span>
                </div>
              </li>
              <li class = "mgt_c3">
                <p class = "mgt_title">Loss</p>
                <div class = "mgt_l">
                  <div style = "width:50%"></div>
                </div>
                <div class = "mgt_r">
                  <span>57.8% (8)</span>
                </div>
              </li>
            </ul>
          </li>
          <li>
            <div class = "mg_title"><span>AH</span><span class = "mg_odds">(0.5/1)</span></div>
            <ul class = "mg_total">
              <li class = "mgt_c1">
                <p class = "mgt_title">Home Win</p>
                <div class = "mgt_l">
                  <div style = "width:50%"></div>
                </div>
                <div class = "mgt_r">
                  <span>57.8% (8)</span>
                </div>
              </li>
              <li class = "mgt_c3">
                <p class = "mgt_title">Away Win</p>
                <div class = "mgt_l">
                  <div style = "width:50%"></div>
                </div>
                <div class = "mgt_r">
                  <span>57.8% (8)</span>
                </div>
              </li>
            </ul>
          </li>
          <li>
            <div class = "mg_title"><span>Over/Under</span><span class = "mg_odds">(3)</span></div>
            <ul class = "mg_total">
              <li class = "mgt_c1">
                <p class = "mgt_title">Over</p>
                <div class = "mgt_l">
                  <div style = "width:50%"></div>
                </div>
                <div class = "mgt_r">
                  <span>57.8% (8)</span>
                </div>
              </li>
              <li class = "mgt_c3">
                <p class = "mgt_title">Under</p>
                <div class = "mgt_l">
                  <div style = "width:50%"></div>
                </div>
                <div class = "mgt_r">
                  <span>57.8% (8)</span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class = "m_point" v-if = "tabIndex == 2">
        <p class = "mp_tip">Checking Quota : 0/20</p>
        <ul class = "mp_list">
          <li class = "cardBox">
            <div class = "c_info">
              <p class = "ci_p1">Master Dayuan</p>
              <p class = "ci_p2">重点投注胜率 : 84%</p>
              <em class = "ci_img"><img src = "../../static/image/head_pic.png"/></em>
              <a class = "ci_btn" href = "javascript:void(0);">His Guess</a>
            </div>
            <ul class = "c_bet">
              <li>
                <span class = "cb_name">1x2</span>
                <span class = "cb_odds">Away Win 6.5</span>
                <span class = "cb_handicap">(0.5/1)</span>
                <em class = "cb_result cb_p">P</em>
              </li>
              <li>
                <span class = "cb_name">AH</span>
                <span class = "cb_odds">Away Win 6.5</span>
                <span class = "cb_handicap">(0.5/1)</span>
                <em class = "cb_result cb_l">L</em>
              </li>
              <li>
                <span class = "cb_name">Over/Under</span>
                <span class = "cb_odds">Away Win 6.5</span>
                <span class = "cb_handicap">(0.5/1)</span>
                <em class = "cb_result cb_w">W</em>
              </li>
            </ul>
          </li>
          <li class = "cardBox cardBoxOn">
            <div class = "c_info">
              <p class = "ci_p1">Master Dayuan</p>
              <p class = "ci_p2">重点投注胜率 : 84%</p>
              <em class = "ci_img"><img src = "../../static/image/head_pic.png"/></em>
              <a class = "ci_btn" href = "javascript:void(0);">His Guess</a>
            </div>
            <ul class = "c_bet">
              <li>
                <span class = "cb_name">1x2</span>
                <span class = "cb_odds">Away Win 6.5</span>
                <span class = "cb_handicap">(0.5/1)</span>
                <em class = "cb_result cb_p">P</em>
              </li>
              <li>
                <span class = "cb_name">AH</span>
                <span class = "cb_odds">Away Win 6.5</span>
                <span class = "cb_handicap">(0.5/1)</span>
                <em class = "cb_result cb_l">L</em>
              </li>
              <li>
                <span class = "cb_name">Over/Under</span>
                <span class = "cb_odds">Away Win 6.5</span>
                <span class = "cb_handicap">(0.5/1)</span>
                <em class = "cb_result cb_w">W</em>
              </li>
            </ul>
          </li>
        </ul>
        <div class = "moreBox">
          <a @click = "nextPage" href = "javascript:void(0);">{{txtLang[curLang]['lotteryMore']}}</a>
        </div>
      </div>

      <div class = "m_point" v-if = "tabIndex == 3">
        <ul class = "mp_list pt20">
          <li class = "cardBox cardBoxCheck">
            <div class = "c_info">
              <p class = "ci_p1">Master Dayuan</p>
              <p class = "ci_p2">查看了你的竞猜方案</p>
              <em class = "ci_img"><img src = "../../static/image/head_pic.png"/></em>
              <p class = "ci_ticket">获得: <span>10</span></p>
            </div>
          </li>
        </ul>
        <div class = "moreBox">
          <a @click = "nextPage" href = "javascript:void(0);">{{txtLang[curLang]['lotteryMore']}}</a>
        </div>
      </div>
    </div>
    <LoadingBox v-show = "loadSH"/> 
  </div>
</template>

<script>
import None from './common/None'
import LoadingBox from './common/Loading'

export default {
  name: 'HelloWorld',
  components:{
    None,
    LoadingBox
  },
  data () {
    return {
      loadSH:false,
      tabIndex:3,
      //list:[{"order_id":"202001171428567419940918","home_team_name":"Hansa Rostock","home_team_scope":0,"away_team_name":"Lyngby","away_team_scope":0,"play_type_id":1,"play_type_option_id":"1","play_type_option_odds":2.18,"coin":100,"handicap":0,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579242536},{"order_id":"202001171428568540429821","home_team_name":"Hansa Rostock","home_team_scope":0,"away_team_name":"Lyngby","away_team_scope":0,"play_type_id":3,"play_type_option_id":"2","play_type_option_odds":0.81,"coin":100,"handicap":3,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579242536},{"order_id":"202001171428563849198316","home_team_name":"St.Polten","home_team_scope":0,"away_team_name":"SV Horn","away_team_scope":0,"play_type_id":2,"play_type_option_id":"1","play_type_option_odds":1.03,"coin":100,"handicap":-1.25,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579242536},{"order_id":"202001171415455954450530","home_team_name":"Burnley","home_team_scope":0,"away_team_name":"Leicester City","away_team_scope":0,"play_type_id":1,"play_type_option_id":"1","play_type_option_odds":16,"coin":100,"handicap":0,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579241745},{"order_id":"202001171059463894026921","home_team_name":"Adelaide United","home_team_scope":1,"away_team_name":"Melbourne Victory FC","away_team_scope":0,"play_type_id":1,"play_type_option_id":"2","play_type_option_odds":3.3,"coin":100,"handicap":0,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579229986},{"order_id":"202001171040465071474143","home_team_name":"Menemen Belediye Spor","home_team_scope":0,"away_team_name":"Giresunspor","away_team_scope":0,"play_type_id":1,"play_type_option_id":"3","play_type_option_odds":3.2,"coin":100,"handicap":0,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579228846},{"order_id":"202001171037562065745927","home_team_name":"FC Juarez","home_team_scope":4,"away_team_name":"Pumas UNAM","away_team_scope":4,"play_type_id":3,"play_type_option_id":"1","play_type_option_odds":1.05,"coin":100,"handicap":2.25,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579228676},{"order_id":"202001171020005121262263","home_team_name":"FC Juarez","home_team_scope":4,"away_team_name":"Pumas UNAM","away_team_scope":4,"play_type_id":2,"play_type_option_id":"1","play_type_option_odds":0.98,"coin":100,"handicap":0,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579227600},{"order_id":"202001170925112676633828","home_team_name":"Adelaide United","home_team_scope":1,"away_team_name":"Melbourne Victory FC","away_team_scope":0,"play_type_id":2,"play_type_option_id":"1","play_type_option_odds":0.85,"coin":100,"handicap":-0.5,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579224311},{"order_id":"202001170925115335280439","home_team_name":"Adelaide United","home_team_scope":1,"away_team_name":"Melbourne Victory FC","away_team_scope":0,"play_type_id":3,"play_type_option_id":"1","play_type_option_odds":1.06,"coin":100,"handicap":3.25,"user_get_coin":false,"status":1,"result_status":0,"game_status":1,"datetime":1579224311}],
      list:[],
      page:1,
      next:false,
    }
  },
  methods: {
    toDetail(id){
      this.$router.push({name:'guessOrderDetail',query:{id:id}})
    },
    back(){
      this.$router.back(-1)
    },
    nextPage(){
      return;
      this.page++;
      var _this = this;
      setTimeout(_this.getList,10);
    },
    tab(index){
      this.tabIndex = index;
      this.page = 1;
      var _this = this;
      //setTimeout(_this.getList,10);
    },
  	getList(){
      var statusArr = [0,2,1,3];
      var token = localStorage.getItem('guess_token') == null ? '' : '&token=' + localStorage.getItem('guess_token');
      this.loadSH = true;

      this.axios.get(this.getHost() + '/orders/list?lan=' + this.langIndex + '&status=' + statusArr[this.tabIndex] + '&page=' + this.page + token).then(
          (response)=>{
          var re = response.data;
          if(re.code == 200){
            //读取联赛列表数据，默认全不选
            this.loadSH = false;
            if(this.page == 1){
              this.list = re.data.list;
            }
            else{
              this.list = this.list.concat(re.data.list);
            }
            
            this.next = re.data.next;
          }
          else if(re.code == 401){
            this.gotoLogin();
          }
          else{
            alert(re.message);
          }
      }).catch((response)=>{
        console.log(response);
      });
    },
  },
  created(){
  	//控制台查看变量
    window.vueVar = this;
    var that = this;
    //this.delStorage('guess_token');
    this.isUserLogin({
        source: this.source[this.curLang],
        platform: 2,
        success: function(data){
            if(data == 1){
                
            }else{
                //that.isLoadingShow = false;
                //return;
            }
            //that.getList();
        }
    });
  }
}
</script>

<style scoped>


.m_point .mp_tip{font-size:24px;color:#fff;text-align:right;padding-top:44px;padding-bottom:24px;padding-right:24px}
.m_point .pt20{padding-top:20px}
.cardBox{margin-bottom:18px}
.cardBox .c_info{position:relative;background:#232048;border-radius:16px}
.cardBox .c_info .ci_p1{color:#bbbabf;font-size:24px;font-weight:bolder;padding-top:40px;padding-left:128px}
.cardBox .c_info .ci_p2{color:#fff;font-size:30px;font-weight:bolder;padding-bottom:34px;padding-left:128px}
.cardBox .c_info .ci_img{position:absolute;top:50%;left:32px;width:74px;height:74px;transform:translateY(-50%);-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);}
.cardBox .c_info .ci_img img{width:100%;height:100%;border-radius:400px}
.cardBox .c_info .ci_img i{position:absolute;right:0;bottom:0;width:24px;height:24px;background:url('../../static/image/icon_vip.png') no-repeat center center;background-size:100%}
.cardBox .c_info .ci_btn{position:absolute;top:50%;right:32px;background:#6371ea;width:160px;height:58px;line-height:58px;border-radius:10px;color:#fff;font-size:24px;font-weight:bolder;text-align:center;transform:translateY(-50%);-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);}
.cardBox .c_info .ci_ticket{position:absolute;top:50%;right:32px;color:#fff;font-size:24px;transform:translateY(-50%);-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);}
.cardBox .c_info .ci_ticket span{margin-left:6px;padding-left:36px;color:#d476e2;background:url('../../static/image/coupon_i.png') no-repeat left center;background-size:30px}
.cardBox .c_bet{display:none;border-top:2px solid #4f4c70;padding-top:24px;padding-bottom:6px;overflow:hidden;margin:0 32px}
.cardBox .c_bet li{position:relative;margin-bottom:20px;font-size:0}
.cardBox .c_bet span{display:inline-block;vertical-align:middle;margin-right:10px}
.cardBox .c_bet .cb_name{font-size:14px;color:#bbbabf;border:2px solid #bbbabf;border-radius:30px;min-width:94px;text-align:center;height:20px;line-height:20px}
.cardBox .c_bet .cb_odds{font-size:24px;color:#00ecfd;margin-right:14px}
.cardBox .c_bet .cb_handicap{font-size:24px;color:#6371ea}
.cardBox .c_bet .cb_result{position:absolute;top:50%;right:0px;border-radius:200px;width:40px;height:40px;line-height:40px;background:#000;font-size:24px;color:rgba(255,255,255,0.7);text-align:center;transform:translateY(-50%);-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);}
.cardBox .c_bet .cb_w{background:#e74f6b}
.cardBox .c_bet .cb_p{background:#5d8ef9}
.cardBox .c_bet .cb_l{background:#00d9cd}
.cardBoxOn{background:#3b3860;border-radius:16px}
.cardBoxOn .c_info{background:none}
.cardBoxOn .c_info .ci_btn{display:none}
.cardBoxOn .c_bet{display:block}
.cardBoxCheck .c_info .ci_p2{font-size:24px}


/*头部*/
.header{z-index:100;position:fixed;top:0;left:0;width:100%;height:120px;background:#232048}
.header .h_title{font-size:40px;color:#fff;line-height:120px;text-align:center}
.header .h_btn{width:120px;height:120px;position:absolute;top:0;left:0}
.header .h_btn:after{display:block;content:'';width:24px;height:24px;margin-top:-12px;margin-left:-12px;border-top:4px solid #fff;border-left:4px solid #fff;position:absolute;top:50%;left:50%;transform:rotate(-45deg);-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-ms-transform:rotate(-45deg);-o-transform:rotate(-45deg);}
/*比赛信息*/
.match{position:fixed;z-index:100;top:120px;left:0;width:100%;background:#171531;height:210px}
.match .m_box{width:640px;height:100%;margin:0 auto;background:url('../../static/image/matchBg.png') no-repeat center bottom;background-size:640px;}
.match .m_box .mb_time{font-size:20px;color:#bbbabf;text-align:center;font-weight:bolder;height:54px;box-sizing:border-box;padding-top:24px}
.match .m_box .mb_info{font-size:0;}
.match .m_box .mb_info li{display:inline-block;vertical-align:top;}
.match .m_box .mb_info .mb_center{width:30%;text-align:center;font-size:48px;font-weight:bolder;color:#fff;padding-top:16px;}
.match .m_box .mb_info .mb_sider{width:35%;text-align:center}
.match .m_box .mb_info .mb_img{width:68px;height:68px;border-radius:200px;overflow:hidden;margin:0 auto 10px}
.match .m_box .mb_info .mb_img img{width:100%;}
.match .m_box .mb_info .mb_name{color:#fff;font-weight:bolder;font-size:20px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
/*tab栏*/
.nav{position:fixed;z-index:100;top:330px;left:0;width:100%;background:#171531}
.nav ul{background:#232048;border-radius:16px;font-size:0;margin:30px 22px 10px;}
.nav ul li{height:76px;border-left:2px solid #171531}
.nav ul li.noBorder{border:none}
.nav ul li div{color:#fff;font-size:30px;text-align:center;line-height:36px}
.nav ul li.on div{color:#00ecfd}
/*内容*/
.main{padding:440px 22px 120px;}

.m_guess .mg_title{height:72px;padding-left:32px}
.m_guess .mg_title span{line-height:84px;color:#bbbabf;font-size:24px;margin-right:16px}
.m_guess .mg_title .mg_odds{color:#6371ea}
.m_guess .mg_option{background:#3b3860;height:96px}
.m_guess .mg_option li{border-left:2px solid #171531;position:relative}
.m_guess .mg_option li.noBorder{border:none}
.m_guess .mg_option p{color:#fff;text-align:center;font-size:24px}
.m_guess .mg_option p .odds_up,
.m_guess .mg_option p .odds_down{position:relative;}
.m_guess .mg_option p .odds_up:after,
.m_guess .mg_option p .odds_down:after{display:block;position:absolute;width:10px;height:20px;content:'';right:-20px;top:50%;margin-top:-10px;background-repeat:no-repeat;background-position:center center;background-size:100% 100%}
.m_guess .mg_option p .odds_up:after{background-image:url('../../static/image/to_up.png');}
.m_guess .mg_option p .odds_down:after{background-image:url('../../static/image/to_down.png');}
.m_guess .mg_option .on{display:none;position:absolute;width:24px;height:20px;background:#00ecfd url('../../static/image/bet_on.png') no-repeat 2px center;background-size:16px 12px;top:0;left:0;border-bottom-right-radius:16px}
.m_guess .mg_option .on2{display:none;background:#232048;position:absolute;top:0;left:0;font-size:14px;color:#00ecfd;padding:0px 16px 4px;border-bottom-right-radius:16px}
.m_guess .mg_option li.selected{border:2px solid #00ecfd}
.m_guess .mg_option li.selected .on{display:block}
.m_guess .mg_option li.betOn .on2{display:block}
.m_guess .locked{background:#292648}
.m_guess .locked p{color:#4d4b63}
.m_guess .mg_point{padding-top:38px;}
.m_guess .mg_point .mgp_btn{padding-bottom:24px}
.m_guess .mg_point .mgp_btn a{outline: none;;background:#2e1b34 url('../../static/image/good.png') no-repeat 90px center;background-size:28px 28px;margin:0 auto;display:block;height:60px;line-height:60px;color:#fb5051;border:2px solid #fb5051;border-radius:30px;font-size:24px;width:274px;padding-left:46px;text-align:center}
.m_guess .mg_point .mgp_tip{font-size:18px;color:#3b3860;text-align:center;line-height:30px}
.m_guess .mg_point .mgp_copy{font-size:0;text-align:center;height:40px;padding-bottom:30px}
.m_guess .mg_point .mgp_l,
.m_guess .mg_point .mgp_r{display:inline-block;vertical-align:middle;}
.m_guess .mg_point .mgp_l{color:#fff;font-size:20px;margin-right:32px;padding-left:50px;height:40px;line-height:40px;background:url('../../static/image/good2.png') no-repeat left center;background-size:40px}
.m_guess .mg_point .mgp_r{height:40px}
.m_guess .mg_point .mgp_r a{outline: none;display:block;color:#6371ea;font-size:24px;line-height:40px}
.m_guess .mg_total{background:#232048;padding:10px 32px 28px;border-radius:16px}
.m_guess .mg_total li{font-size:0;position:relative;padding-top:36px;}
.m_guess .mg_total .mgt_title{position:absolute;font-size:20px;color:#ffffff;top:10px;left:4px}
.m_guess .mg_total .mgt_l,
.m_guess .mg_total .mgt_r{display:inline-block;vertical-align:middle}
.m_guess .mg_total .mgt_l{width:480px;height:18px;background:#3b3860;border-radius:8px}
.m_guess .mg_total .mgt_l div{height:18px;background:#fff;border-radius:8px}
.m_guess .mg_total .mgt_r{padding-left:18px;font-size:24px;color:#fff}
.m_guess .mg_total .mgt_c1 .mgt_l div{background:#fb7759}
.m_guess .mg_total .mgt_c1 .mgt_r span{color:#fb7759}
.m_guess .mg_total .mgt_c2 .mgt_l div{background:#5e6df9}
.m_guess .mg_total .mgt_c2 .mgt_r span{color:#5e6df9}
.m_guess .mg_total .mgt_c3 .mgt_l div{background:#99ca45}
.m_guess .mg_total .mgt_c3 .mgt_r span{color:#99ca45}


.moreBox a{outline: none;display:block;font-size:36px;color:#6371ea;text-align:center;height:106px;line-height:106px}
</style>








// WEBPACK FOOTER //
// src/components/guessDetail.vue